<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="checked-bag">
                    <icon name="shopping-bag"></icon>
                    เช็คถุง
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="bag-type">
                    <icon name="shopping-bag"></icon>
                    ประเภทถุง
                </b-nav-item>&nbsp;
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "checked-bag-layout",
        methods:{

        }
    }
</script>

<style scoped>
</style>